import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/main.css';
import './styles/lyra-theme.css';
import App from './App.tsx';
import { AIProvider } from './context/AIContext.jsx';
import { AgentsProvider } from './context/AgentsContext.jsx';
import { RuntimeProvider } from './context/RuntimeContext.tsx';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AIProvider>
        <RuntimeProvider>
      <AgentsProvider>
        <App />
      </AgentsProvider>
        </RuntimeProvider>
    </AIProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
